const validate = (values) => {
    const errors = {};
  
    if (!values.OtherAttendeesNotes) {
        errors.OtherAttendeesNotes = 'Please enter other notes';
    }
    if (!values.OtherObservedNotes) {
        errors.OtherObservedNotes = 'Please enter other notes';
    }
    if (!values.OtherBehaviorNotes) {
        errors.OtherBehaviorNotes = 'Please enter other notes';
    }
    if (!values.SummaryOfBehaviorObservedAndOutcome) {
        errors.SummaryOfBehaviorObservedAndOutcome = 'Please enter summary';
    }    
    if (!values.OtherStrategiesNotes) {
        errors.OtherStrategiesNotes = 'Please enter other notes';
    }
    if (!values.SummaryOfProgressAndSuggestions) {
        errors.SummaryOfProgressAndSuggestions = 'Please enter summary';
    }
    if (!values.OtherNotes) {
        errors.OtherNotes = 'Please enter other notes';
    }
    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_Hyperion/validate.js